import { addDays, format, parseISO } from "date-fns";

const UTC = "UTC";

const formatters = new Map<string, Intl.DateTimeFormat>();

function getFormatter(timeZone: string) {
  const key = timeZone || UTC;
  const existing = formatters.get(key);
  if (existing) return existing;

  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: key,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  formatters.set(key, formatter);
  return formatter;
}

export function getCurrentUserTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || UTC;
}

export function normalizeTimeZone(timeZone?: string | null): string {
  const fallback = getCurrentUserTimeZone();
  if (!timeZone) return fallback;

  try {
    // Throws RangeError for invalid IANA timezone IDs.
    Intl.DateTimeFormat("en-US", { timeZone });
    return timeZone;
  } catch {
    return fallback;
  }
}

export function getDateKeyInTimeZone(
  date: Date = new Date(),
  timeZone?: string | null
): string {
  const tz = normalizeTimeZone(timeZone);
  const parts = getFormatter(tz).formatToParts(date);

  const year = parts.find((part) => part.type === "year")?.value;
  const month = parts.find((part) => part.type === "month")?.value;
  const day = parts.find((part) => part.type === "day")?.value;

  if (!year || !month || !day) {
    return format(date, "yyyy-MM-dd");
  }

  return `${year}-${month}-${day}`;
}

export function addDaysToDateKey(dateKey: string, days: number): string {
  return format(addDays(parseISO(dateKey), days), "yyyy-MM-dd");
}
